<script setup lang="ts">
import { useData } from "vitepress";
import { computed } from "vue";
import { data as projects } from "../../../../projects/index.data.js";

const { page } = useData();

const isArticlePage = computed(() => {
  return (
    page.value.relativePath.startsWith("articles/") &&
    page.value.relativePath !== "articles/index.md"
  );
});

const isDemoPage = computed(() => {
  return (
    page.value.relativePath.startsWith("demos/") &&
    page.value.relativePath !== "demos/index.md"
  );
});

// A project article is any file in projects/<slug>/ other than index.md.
const projectArticleSlug = computed(() => {
  const match = page.value.relativePath.match(/^projects\/([^/]+)\/(.+)\.md$/);
  return match && match[2] !== "index" ? match[1] : null;
});

const parentProject = computed(() => {
  if (!projectArticleSlug.value) return null;
  return (
    projects.find((p) => p.url === `/projects/${projectArticleSlug.value}/`) ||
    null
  );
});

const backLink = computed(() => {
  if (parentProject.value) {
    return {
      href: parentProject.value.url,
      text: `Back to ${parentProject.value.title}`,
    };
  }
  if (isArticlePage.value) {
    return { href: "/articles/", text: "Back to Articles" };
  }
  if (isDemoPage.value) {
    return { href: "/demos/", text: "Back to Demos" };
  }
  if (projectArticleSlug.value) {
    return { href: "/projects/", text: "Back to Projects" };
  }
  return null;
});
</script>

<template>
  <a v-if="backLink" :href="backLink.href" class="back-link">
    &larr; {{ backLink.text }}
  </a>
</template>

<style scoped>
.back-link {
  display: inline-block;
  margin-bottom: 1.5rem;
  color: var(--color-text-muted);
  text-decoration: none;
  font-size: 0.9rem;
}

.back-link:hover {
  color: var(--color-accent);
}
</style>
